import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Only scroll if this element has the data-scroll-now attribute
    // This attribute is added only after form submission, not on page refresh
    if (this.element.dataset.scrollNow === "true") {
      this.scrollToElement()
      // Remove the attribute after scrolling so it doesn't scroll again
      delete this.element.dataset.scrollNow
    }
  }

  scrollToElement() {
    // Small delay to ensure the element is fully rendered
    setTimeout(() => {
      this.element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }, 100)
  }
}
